// extracted by mini-css-extract-plugin
module.exports = {"con":"msg_con__L6ydS","msg":"msg_msg__PJ95N","ico":"msg_ico__1ZmTH","bz":"msg_bz__3W_EA","tex":"msg_tex__25mi1","err":"msg_err__pZoo8","close":"msg_close__Y8Wdo"};